import { AppLayout, Modal, tokens } from '@welbe/web-design-system';
import { ReactNode } from 'react';
import { SelectCompanies } from './components/SelectCompanies/SelectCompanies';
import { useLayout } from './Layout.hooks';
import { LayoutContainer } from './Layout.style';

type LayoutProps = {
	children: ReactNode;
};

export const Layout = ({ children }: LayoutProps): JSX.Element => {
	const { sidebar, navbar, activeModalConfig, handleCloseModal } = useLayout();

	return (
		<LayoutContainer>
			<AppLayout
				id="AppLayoutCompanies"
				sidebar={sidebar}
				navbar={{
					...navbar,
					slotActionComponent: [<SelectCompanies key={1} />],
				}}
			>
				{activeModalConfig && (
					<Modal
						open
						headerIcon={
							<activeModalConfig.icon
								fontSize={40}
								color={tokens.color_white}
							/>
						}
						borderRadius="4px"
						width={activeModalConfig.width}
						onClose={handleCloseModal}
						closeButton
					>
						<activeModalConfig.component onClose={handleCloseModal} />
					</Modal>
				)}
				{children}
			</AppLayout>
		</LayoutContainer>
	);
};
